import { ModalController } from '@ionic/angular';
import { Input, Directive, OnInit } from '@angular/core';

@Directive()
export abstract class Modal implements OnInit {
  @Input() protected title: string;
  @Input() protected message: string;
  @Input() protected actionRequested = false;
  @Input() protected actionButtonText = 'Confirmer';
  @Input() protected cancelButtonText = '';

  constructor(
    protected modalCtrl: ModalController
  ) {}

  close(data: any = null) {
    this.modalCtrl.dismiss(data);
  }

  ngOnInit() {}
}